/**
 * @module state.additionalInfo
 * @property {String} name Sinister id.
 * @property {String} surname Sinister id.
 * @property {String} phone Sinister id.
 *  triggering sinister analysis.
 */
const getDefaultState = () => ({
  name: null,
  surname: null,
  sinisterAddress: null,
  email: null,
  sinisterDate: null,
  numPolice: null,
  scoreAsk: null,
  validateContract: null,
  inmobiliere: false,
  embellissement: null,
  mobiliere: false,
  piscine: false,
  exterieur: false,
  currentClaim: null,
  litigationAlertAbsence: null,
  gagNumber: 0,
  renNumber: 0,
  sinisterCause: null,
  sinisterPlace: null,
  damagePlace: null,
  causeRepaired: null,
  thirdPartyInvolved: null
})

export { getDefaultState }
